<template>
  <div
    class="import-sheet"
    @click="importFile()"
  >
    <aha-icon name="document-excel" class="mr-1"></aha-icon>
    <span>{{ $i18nPresenter.t('Import Excel') }}</span>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import util from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  computed: {
    ...mapGetters(['isDisableWhenNotOwner']),
  },
  methods: {
    ...mapActions(['setImportSheetModalStateAction']),
    importFile() {
      if (this.$store.state.isDisableEditPresentation) return
      this.setImportSheetModalStateAction(true)
      util.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Import Sheet File > Click Import',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.import-sheet {
  @apply flex items-center cursor-pointer hover:text-primary-90 pl-3;
  text-align: center;
  background-color: #fff;
}
</style>
